import styled from 'styled-components'
import { ZingTheme } from '../../../../assets/theme/types'

export const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 1020;
  background: ${({ theme }) => (theme as ZingTheme).colors.white};
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
`

export const Container = styled.div`
  width: 100%;
  margin-inline: auto;
  padding-inline: 1rem;
  padding-block: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media screen and (min-width: 576px) {
    max-width: 540px;
  }

  @media screen and (min-width: 768px) {
    max-width: 720px;
  }

  @media screen and (min-width: 992px) {
    max-width: 960px;
  }

  @media screen and (min-width: 1200px) {
    max-width: 1140px;
  }

  @media screen and (min-width: 1400px) {
    max-width: 1320px;
  }
`

export const BrandButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
`

export const MobileQuickLink = styled.a`
  display: none;
  font-family: ${({ theme }) => (theme as ZingTheme).fonts.body};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration: none;
  color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  white-space: nowrap;
  cursor: pointer;

  @media screen and (max-width: 992px) {
    display: inline;
  }
`

export const ToggleButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  color: rgba(0, 0, 0, 0.55);
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  cursor: pointer;

  @media screen and (max-width: 992px) {
    display: flex;
  }
`

export const HamburgerIcon = styled.span`
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
`

export const CollapseWrapper = styled.div<{ $isOpen: boolean }>`
  display: grid;
  width: 100%;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows 0.35s ease;

  @media screen and (min-width: 993px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    flex-wrap: wrap;
    width: auto;
    grid-template-rows: unset;
    transition: none;
  }
`

export const CollapseInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding-top: 0.75rem;
  overflow: hidden;
  min-height: 0;

  @media screen and (min-width: 993px) {
    display: contents;
  }
`

export const NavList = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`

export const Logo = styled.img<{ $logoHeight?: string; $logoWidth?: string }>`
  width: 100%;
  max-width: ${({ $logoWidth }) => $logoWidth ?? '9.375rem'};
  height: auto;
  max-height: ${({ $logoHeight }) => $logoHeight ?? '3.75rem'};
  cursor: pointer;
`

export const HeaderLink = styled.a`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1rem;
  text-decoration: none;
  color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
  margin-inline: 2rem;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  }

  @media screen and (max-width: 992px) {
    margin-inline: 0;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 992px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`

export const LoginLink = styled.a`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  text-decoration: none;
  color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  margin-inline: 1rem;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => (theme as ZingTheme).colors.primaryDark};
  }

  @media screen and (max-width: 992px) {
    margin-inline: 0;
    margin-right: 1rem;
  }
`
